export default __webpack_public_path__ + "static/media/xx99-mark-i-in-person.3e6e3920.png";